import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { LOGIN_BG_COLOR, PAGINATOR_BG_COLOR, WHITE } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: LOGIN_BG_COLOR
  },
  list: {
    height: '100%'
  },
  addButton: {
    position: 'absolute',
    right: 30,
    bottom: 30
  },
  button: {
    fontSize: '0.9em',
    maxHeight: 32,
    boxSizing: 'border-box',
    fontWeight: 400,
    textTransform: 'none',
    padding: '5px 6px',
    margin: '2px',
    minWidth: 45,
    marginLeft: 30,
  },
  editList: {
    width: '100%'
  },
  searchBase: {
    margin: '4px auto -15px auto',
    width: '95%'
	},
	paginator:{
    background: PAGINATOR_BG_COLOR,
    padding: '10px 0',
    fontSize: '16px'
  },
  customPaginationWrap: {
    background: PAGINATOR_BG_COLOR,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  showingResults: {
    color: WHITE,
    paddingRight: 30,
  },
  paginatorNumber: {
    width: 40,
    minWidth: 1,
    height: 24,
    border: 'none',
    padding: '0 5px',
    borderRadius: 5,
    textAlign: 'center',
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/list/List.styles.js